export * from './firebase';
export var reportError = function (err, silent) {
    if (silent === void 0) { silent = false; }
    console.error(err);
    if (!silent)
        alert(err.message);
};
export var directMessageId = function (me, other) {
    return me < other ? me + "-" + other : other + "-" + me;
};
export var detectLocation = function () {
    return new Promise(function (resolve, reject) {
        var geo = window.navigator.geolocation;
        if (!geo) {
            reject(new Error("Your browser doesn't support geolocation"));
            return;
        }
        geo.getCurrentPosition(function (pos) {
            resolve(pos.coords);
        }, function (err) {
            reject(new Error('Cannot get location'));
        }, { enableHighAccuracy: true });
    });
};
//# sourceMappingURL=index.js.map